import _defineProperty2 from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './Sorting.css';
import React, { useContext, useMemo, useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ReactComponent as SortIcon } from "../../../resources/icons/sort-arrows-v1.svg";
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { ReactComponent as IconArrowLeft } from '../../../resources/icons/IconArrowLeft.svg';
import { ReactComponent as IconArrowRight } from '../../../resources/icons/IconArrowRight.svg';
import { get, canUseDOM } from '../../../utils';
import { SORT_QUERY_NAME } from '../ListingOffersAndDeals';
import { addQueryString, deleteQueryString } from '../../Listing/index';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
var OFFER_AND_DEAL_SORTING_ID = 'offer-and-deal-id-value';
var Sorting = function Sorting(_ref) {
  var values = _ref.values,
    deskLabelText = _ref.deskLabelText,
    mobileLabelText = _ref.mobileLabelText,
    defaultSortValue = _ref.defaultSortValue,
    value = _ref.value,
    clearText = _ref.clearText,
    setSort = _ref.setSort,
    setListingFilter = _ref.setListingFilter,
    eventsAnalytics = _ref.eventsAnalytics,
    params = _ref.params;
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var history = useHistory();
  var fieldOpenedRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    fieldVisible = _useState2[0],
    setFieldVisible = _useState2[1];
  var valuesHash = useMemo(function () {
    return values.reduce(function (acc, item) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty2({}, get(item, 'sortingIndexPrefix.jss.value'), get(item, 'displayName')));
    }, {});
  }, [values]);
  var renderHighlightedValue = function renderHighlightedValue(s) {
    if (!s) return s;
    var splitted = s.split(/：|:/); // first for zn language, second for others
    if (splitted.length === 2) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "sorting-button__black-label"
      }, splitted[0], ":"), " ", /*#__PURE__*/React.createElement("span", null, splitted[1]));
    }
    return s;
  };
  var hideDD = function hideDD(e) {
    if (fieldOpenedRef.current) {
      var mobileDevice = window.matchMedia("(max-width: 991px)").matches;
      if (e.type === 'scroll') {
        if (mobileDevice) return;
      }
      if (e.type === 'click') {
        if (mobileDevice || e.target.closest("#".concat(OFFER_AND_DEAL_SORTING_ID))) return;
      }
      setFieldVisible(false);
    }
  };
  useEffect(function () {
    fieldOpenedRef.current = fieldVisible;
  }, [fieldVisible]);
  useEffect(function () {
    if (canUseDOM) {
      window.addEventListener('scroll', hideDD);
      document.addEventListener("click", hideDD);
    }
    return function () {
      if (canUseDOM) {
        window.removeEventListener('scroll', hideDD);
        document.removeEventListener("click", hideDD);
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    id: OFFER_AND_DEAL_SORTING_ID
  }, /*#__PURE__*/React.createElement("div", {
    className: "sorting-button ".concat(fieldVisible ? 'sorting-button--active' : ''),
    onClick: function onClick() {
      setFieldVisible(!fieldVisible);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "d-lg-none sorting-button__text"
  }, renderHighlightedValue(defaultSortValue === value ? deskLabelText : valuesHash[value])), /*#__PURE__*/React.createElement("span", {
    className: "d-none d-lg-inline sorting-button__text"
  }, renderHighlightedValue(defaultSortValue === value ? deskLabelText : valuesHash[value])), /*#__PURE__*/React.createElement(SortIcon, {
    className: "sorting-button__icon"
  })), fieldVisible && /*#__PURE__*/React.createElement("div", {
    className: "dropdown"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-lg-none dropdown-header"
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__back",
    onClick: function onClick() {
      setFieldVisible(false);
    }
  }, rtl ? /*#__PURE__*/React.createElement(IconArrowRight, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(IconArrowLeft, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "dropdown-header__text"
  }, mobileLabelText), defaultSortValue !== value && /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__clear",
    onClick: function onClick() {
      setFieldVisible(false);
      deleteQueryString(SORT_QUERY_NAME, history);
      setSort(defaultSortValue);
      setListingFilter();
    }
  }, clearText)), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-body"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "sorting-values-list"
  }, /*#__PURE__*/React.createElement("li", {
    className: "sorting-values-list__item ".concat(value === defaultSortValue ? 'sorting-values-list__item--active' : ''),
    onClick: function onClick() {
      setFieldVisible(false);
      deleteQueryString(SORT_QUERY_NAME, history);
      setSort(defaultSortValue);
      setListingFilter();
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['sortingParamAnalytics'], params), defaultSortValue || deskLabelText);
    }
  }, /*#__PURE__*/React.createElement("button", {
    className: "sorting-values-list__item-btn"
  }, deskLabelText)), values.map(function (sortItem) {
    var itemValue = get(sortItem, 'sortingIndexPrefix.jss.value');
    var itemLabel = get(sortItem, 'displayName');
    return /*#__PURE__*/React.createElement("li", {
      className: "sorting-values-list__item ".concat(value === itemValue ? 'sorting-values-list__item--active' : ''),
      key: itemValue,
      onClick: function onClick() {
        setFieldVisible(false);
        addQueryString(SORT_QUERY_NAME, itemValue, history);
        setSort(itemValue);
        setListingFilter();
        tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['sortingParamAnalytics'], params), itemValue);
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "sorting-values-list__item-btn"
    }, itemLabel));
  })))));
};
export default Sorting;
export var commonStyles = "coo2zl";
export var ltrStyles = "l1mbsoo";
export var rtlStyles = "ran4knc";